export default "__VITE_ASSET__CNmeJ8pC__"